import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import RichText from '../rich-text/RichText';
import { MidHeading, TextLink } from '../typography';

export const FaqSearchResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LoadingBox = styled.div`
  align-self: center;
  padding: 100px 0;
`;

export const FaqSearchNoResults = styled.div`
  align-self: center;
  margin: 50px auto;
  text-align: center;

  svg {
    color: ${({ theme }) => theme.primary};
  }
`;

export const FaqSearchLink = styled(TextLink)`
  b {
    background-color: #feede6;
  }
`;

export const FaqSearchContent = styled(RichText)`
  padding-bottom: 20px;
  margin-bottom: 25px;
  border-bottom: 1px solid ${({ theme }) => theme.backgroundLighter};

  b {
    background-color: #feede6;
  }
`;

export const TotalResults = styled(MidHeading)`
  @media (${tabletMax}) {
    font-size: 22px;
  }
`;
